export default {
  SLIDE_TO_RIGHT: 1,
  SLIDE_TO_LEFT: 2,
};
